<template>
    <div>
        <hooper class="evo-slider" :autoPlay="false" :itemsToShow="3" :centerMode="true" :wheelControl="false" :playSpeed="8000" :infiniteScroll="true">
            <slide>
                <div style="text-align: center; padding-left: 2rem; padding-right: 2rem;">
                    <div style="border-radius: .75rem; padding: 1.5rem; background-color: #ffffff;">
                        <img draggable="false" :src="'../img/ESCUT_1930.jpg'" class="img-fluid" alt="" />
                    </div>
                    <h5>1930</h5>
                    <p>A partir de la dictadura franquista, I com a conseqüència de la reglamentació que prohibeix els noms en català o d’origen estranger, es castellanitza el nom del club a “GERONA CLUB de FUTBOL”.</p>
                </div>
            </slide>
            <hooper-navigation slot="hooper-addons"></hooper-navigation>
        </hooper>
    </div>
</template>

<script>
import { Hooper, Slide, Pagination as HooperPagination, Navigation as HooperNavigation } from 'hooper';
import 'hooper/dist/hooper.css';
export default {
    components: {
        Hooper, Slide, HooperPagination, HooperNavigation
    },
    data: () => {
        return {
            currentElement: 0
        }
    }
}
</script>

<style>
:focus {
    border: none;
    outline:none;
}

.hooper {
    height: 100% !important;
}

.hooper-indicator {
    background-color: #fff;
    opacity: 0.25;
}

.hooper-indicator:hover, .hooper-indicator.is-active {
    background-color: #ffffff !important;
    opacity: 1;
}
</style>
